import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, forkJoin, map, mergeAll, of, tap } from 'rxjs';
import { ORingProductFamily, ORingSBU, ORing, ORingSellable, ORingSubSBU, ORingMaterialName, ORingProductSizeValue, ORingProductFamilyName, ORingSBUName, ORingSubSBUName, ORingSellableId, ORingProductTypeName } from '../models/oring.model';
import { ENV_CONFIG, EnvironmentConfig } from 'src/environments/environment.model';
import { LookupValue } from '../models/lookup.model';
import { ORingFilter } from '../store/fromORing.barrel';

@Injectable({
  providedIn: 'root'
})
export class ORingService {
  loadProductFamilies() {
    throw new Error('Method not implemented.');
  }
  endpoint: { url: string; version: string; };

  constructor(
    private http: HttpClient,
    @Inject(ENV_CONFIG) private config: EnvironmentConfig) {
    this.endpoint = this.config.endpoints.oRingsApi;
  }

  get(filter: ORingFilter): Observable<ORing[]> {
    let q = '?$filter=(';
    // if (!!filter.sbuID) q += `SBUID=${filter.sbuID}&`;
    // if (!!filter.subSbuID) q += `subSBUID=${filter.subSbuID}&`;
    // if (!!filter.productFamilyID) q += `productFamilyID=${filter.productFamilyID}&`;
    // if (!!filter.equipmentTypeID) q += `equipmentTypeID=${filter.equipmentTypeID}&`;
    // if (!!filter.pipeSizeID) q += `pipeSizeID=${filter.pipeSizeID}&`;
    // if (!!filter.materialID) q += `materialID=${filter.materialID}&`;

    if (!!filter.closurePartNumber) q += `contains(ClosureList,'${filter.closurePartNumber}')&`;

    if (!!filter.partNumber) q += `contains(PartNumber,'${filter.partNumber})'&`;

    if ((filter.sellableCodes || []).length > 0) {
      const str = filter.sellableCodes!.map(c => `sellableCodes=${c}`).join('&');
      q += str + '&';
    };

    q = q.substring(0, q.length - 1)+')';

    if (q === '?$filter=)') q = '';

    return this.http.get<ORing[]>(`${this.endpoint?.url}api/${this.endpoint.version}/ProductsFlat${q}`);
  }

  /// This gets only the active values for the pipesize lookup
  getPipeSizes(): Observable<ORingProductSizeValue[]> {
    return this.http.get<{SizeList: string}[]>(`${this.endpoint.url}api/${this.endpoint.version}/ProductsFlat?$apply=groupby((sizeList))`)
              .pipe(map(val => { 
                                let flatVal = val
                                                .map(m => m.SizeList.split(','))
                                                .flat()
                                let distinctVal = [...new Set(flatVal)]
                                let returnVal = distinctVal.map(s => ({
                                  ProductSize: parseInt(s)
                                }))

                                return returnVal
                              }));
  }

  getMaterials(): Observable<ORingMaterialName[]> {
    return this.http.get<ORingMaterialName[]>(`${this.endpoint.url}api/${this.endpoint.version}/ProductsFlat?$apply=groupby((materialName))`);
  }

  getProductFamilies(): Observable<ORingProductFamilyName[]> {
    return this.http.get<ORingProductFamilyName[]>(`${this.endpoint.url}api/${this.endpoint.version}/ProductsFlat?$apply=groupby((productFamily))`);
  }

  getSbus(): Observable<ORingSBU[]> {
    return this.http.get<ORingSBU[]>(`${this.endpoint.url}api/${this.endpoint.version}/SBUs`);
  }

  getSubSBUs(): Observable<ORingSubSBU[]> {
    return this.http.get<ORingSubSBU[]>(`${this.endpoint.url}api/${this.endpoint.version}/SubSBUs`);
  }

  /// This gets only the active values for the categories lookup
  // getCategories(): Observable<LookupValue[]> {
  //   return this.http.get<LookupValue[]>(`${this.endpoint.url}api/${this.endpoint.version}/Categories`);
  // }

  getSellables(): Observable<ORingSellableId[]> {
    return this.http.get<ORingSellableId[]>(`${this.endpoint.url}api/${this.endpoint.version}/ProductsFlat?$apply=groupby((sellableWH))`);
  }

  /// This gets only the active values for the product codes lookup
  // getProductCodesForFilter(): Observable<LookupValue[]> {
  //   return this.http.get<LookupValue[]>(`${this.endpoint.url}api/${this.endpoint.version}/ProductCodes`);
  // }

  getProductTypes(): Observable<ORingProductTypeName[]> {
    return this.http.get<ORingProductTypeName[]>(`${this.endpoint.url}api/${this.endpoint.version}/ProductsFlat?$apply=groupby((productType))`);
  }
}
